var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-between sm:justify-center"},[_c('div',{staticClass:"mx-5"}),_c('h3',[_vm._v(" Predictions ")]),_c('div',{staticClass:"mx-5"})])
}]

export { render, staticRenderFns }